const PERIOD_LABELS = { mtd: 'MTD', qtd: 'QTD', ytd: 'YTD', as_on_date: 'As On Date' };

export function PeriodBadge({ period, currentMonthInfo }) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-[#1D4ED8] text-white">{PERIOD_LABELS[period] || period}</span>
      {currentMonthInfo && (
        <>
          <span className="text-[10px] font-semibold text-blue-600">{currentMonthInfo.label}</span>
          <span className="text-[10px] text-slate-300">|</span>
          <span className="text-[10px] font-semibold text-slate-500">{currentMonthInfo.fy_label} {currentMonthInfo.quarter_label}</span>
        </>
      )}
    </div>
  );
}

export function fmtINR(n) {
  if (n == null || isNaN(n)) return '--';
  const a = Math.abs(n);
  const s = n < 0 ? '-' : '';
  if (a >= 1e7) return `${s}${(a / 1e7).toFixed(2)} Cr`;
  if (a >= 1e5) return `${s}${(a / 1e5).toFixed(2)} L`;
  if (a >= 1e3) return `${s}₹${Math.round(a).toLocaleString('en-IN')}`;
  return `${s}₹${a.toLocaleString('en-IN')}`;
}

export function fmtNum(n) {
  if (n == null || isNaN(n)) return '--';
  return Math.round(n).toLocaleString('en-IN');
}

export function fmtSqft(n) {
  if (!n || isNaN(n)) return '--';
  return `${Math.round(n).toLocaleString('en-IN')} Sq.ft`;
}
